import React, { Component } from "react"
import SbEditable from "storyblok-react"

import Headline from "../Headline"
import Modal from "../../Modal"
import ImagesService from "../../../utils/images-service"

import "./styles.scss"


class ImageGallery extends Component {
    constructor(props) {
        super(props)
        this.blok = props.blok
        this.state = {
            openModal: false,
            image: null
        }

        this.t = props.t
        this.images = this.blok.images
        console.log(this.images)

        this.openWindow = this.openWindow.bind(this)
        this.closeWindow = this.closeWindow.bind(this)
        this.nextImage = this.nextImage.bind(this)
        this.previousImage = this.previousImage.bind(this)
    }

    openWindow(image) {
        this.setState({ openModal: true, image: image })
    }

    closeWindow() {
        this.setState({ openModal: false, image: null })
    }

    nextImage(imageId) {
        let nextId = getObjectIndex(this.images, imageId) +1
        if (this.images.length > nextId) {
            this.setState({ openModal: true, image: this.images[nextId] })
        } else {
            this.setState({ openModal: true, image: this.images[0] })
        }
    }

    previousImage(imageId) {
        let previousId = getObjectIndex(this.images, imageId) - 1
        if (previousId >= 0) {
            this.setState({ openModal: true, image: this.images[previousId] })
        } else {
            this.setState({ openModal: true, image: this.images[this.images.length-1] })
        }
    }



    render() {
        return (
            <div className="image-gallery-component">
                <SbEditable content={this.blok}>
                    <Headline blok={this.blok.headline[0]} />
                    <ul>
                    {this.blok.images.map((image) => (
                        <li key={image._uid} onClick={(e) => { this.openWindow(image) }}>
                            <img src={ImagesService(image.image.filename, true, { path: `200x200/smart/filters:format(jpg)`})} srcSet={`${ ImagesService(image.image.filename, true, { path: `200x200/smart/filters:format(jpg)`}) } 1x, ${ ImagesService(image.image.filename, true, { path: `400x400/smart/filters:format(jpg)`}) } 2x`} />
                        </li>
                    ))}
                    </ul>
                </SbEditable>
                {this.state.openModal && 
                <Modal headline="Bildergalerie" closeCallback={this.closeWindow}>
                    <div className="gallery-image">
                        <div className="image-container">
                            <picture>
                                <source srcSet={`${ ImagesService(this.state.image.image.filename, true, { path: `960x540/smart/filters:format(webp)`}) } 1x, ${ ImagesService(this.state.image.image.filename, true, { path: `1920x1080/smart/filters:format(webp)`}) } 2x`} type="image/webp" />
                                <source srcSet={`${ ImagesService(this.state.image.image.filename, true, { path:  `960x540/smart/filters:format(jpeg):quality(60)`}) } 1x, ${ ImagesService(this.state.image.image.filename, true, { path: `1920x1080/smart/filters:format(webp)`}) } 2x`} type="image/jpeg" />
                                <img loading="lazy" src={ImagesService(this.state.image.image.filename, true, { path: `960x540/smart/filters:format(jpeg):quality(60)`})} alt={this.state.image.caption} width="960" height="540" />
                            </picture>
                            <div className="previous" onClick={(e) => { this.previousImage(this.state.image._uid )}} tabindex="0" role="button" title="Zurück">
                                <i className="material-icons">navigate_before</i>
                            </div>
                            <div className="next" onClick={(e) => { this.nextImage(this.state.image._uid )}} tabindex="0" role="button" title="Weiter">
                                <i className="material-icons">navigate_next</i>
                            </div>
                        </div>
                        <div className="meta-information">
                        <div className="caption">{this.state.image.caption}</div>
                            {this.state.image.copyright !== "" &&
                            <div className="author">Copyright: {this.state.image.copyright}</div>
                            }
                        </div>
                    </div>
                </Modal>
                }
            </div>
        )
    }
}

function getObjectIndex(list, id) {
    for (let i=0; list.length>i; i++) {
        if (list[i]._uid === id) {
            return i
        }
    }
    return false
}

export default ImageGallery